import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { useMultiStyleConfig as t, Center as n, VStack as a } from "@chakra-ui/react";
import { Avatar as l } from "../../media/Avatar/Avatar.mjs";
import { Typography as m } from "../../dataDisplay/Typography/Typography.mjs";
import s from "./headerImage.svg.mjs";
const h = ({ userName: r }) => {
  const o = t("GlobalHeaderv2");
  return /* @__PURE__ */ e(
    n,
    {
      sx: o.mobileMenuHeader,
      background: `url("${s}")`,
      children: /* @__PURE__ */ i(a, { spacing: 2, children: [
        /* @__PURE__ */ e(l, { size: "lg", name: r }),
        r && /* @__PURE__ */ e(m, { variant: "subheading2", children: r })
      ] })
    }
  );
};
export {
  h as MobileMenuHeader
};
